import React from "react";
import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 34 },
  show: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: EASE, delay: i * 0.08 },
  }),
};

// Section-level scroll reveal wrapper.
export function Reveal({ children, className = "", delay = 0, y = 34, as = "div", ...rest }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-90px" }}
      transition={{ duration: 0.7, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

// Masked, line-by-line reveal for hero headlines.
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className="reveal-mask">
      <motion.span
        className={`block ${className}`}
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 0.9, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

// Eyebrow / kicker label with a leading rule.
export function Kicker({ children, tone = "green", className = "" }) {
  const color =
    tone === "cream"
      ? "text-[#e8a93d]"
      : tone === "gold"
      ? "text-[#c99311]"
      : "text-[#002355]";
  const rule = tone === "cream" ? "bg-[#e8a93d]" : "bg-[#002355]";
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <span className={`h-px w-8 ${rule} opacity-60`} />
      <span className={`kicker ${color}`}>{children}</span>
    </div>
  );
}

export { EASE };
